import { render, staticRenderFns } from "./defmtrx.vue?vue&type=template&id=0237fdeb&scoped=true&"
import script from "./defmtrx.vue?vue&type=script&lang=js&"
export * from "./defmtrx.vue?vue&type=script&lang=js&"
import style0 from "./defmtrx.vue?vue&type=style&index=0&id=0237fdeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237fdeb",
  null
  
)

export default component.exports